import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useWeb3React } from '@web3-react/core'
import IconExchangeSmallIcon from '~/assets/images/exchange-small-icon.svg'
import IconExchangeSmallIconGray from '~/assets/images/exchange-small-icon-gray.svg'
import IconRight from '~/assets/images/right.svg'
import { useBreakpoint } from '~/hooks'
import { getExplorerTransactionLink } from '~/utils/chain'
import OrderStatus from './components/OrderStatus'
import {
  StyledTradeDetail,
  StyledTradeDetailExchange,
  StyledTradeDetailHeader,
  StyledTradeDetailLink,
  StyledTradeDetailSection,
  StyledTradeDetailTitle,
} from './styled'
import { TRADE_STATUS } from './types'

const TradeDetail = ({
  fromToken,
  sectionData,
  toToken,
  tradeType,
  txHash,
  onSuccess,
  status,
}) => {
  const { isMobile } = useBreakpoint()
  const { t } = useTranslation()
  const { chainId } = useWeb3React()

  useEffect(() => {
    if (status && status === TRADE_STATUS.SUCCESS && onSuccess) {
      onSuccess()
    }
  }, [status, onSuccess])

  return (
    <StyledTradeDetail>
      <StyledTradeDetailHeader>
        <StyledTradeDetailTitle>
          <div className="modal-title-inner">{t('trade_detail')}</div>
        </StyledTradeDetailTitle>
        <StyledTradeDetailExchange>
          <span className="from-token">{fromToken}</span>
          {toToken && (
            <>
              <img
                className="exchange-icon"
                src={
                  isMobile ? IconExchangeSmallIconGray : IconExchangeSmallIcon
                }
              />
              <span className="to-token">{toToken}</span>
            </>
          )}
        </StyledTradeDetailExchange>
      </StyledTradeDetailHeader>
      <StyledTradeDetailSection>
        {[...sectionData].filter(Boolean).map((item) => {
          return (
            <div className="modal-section-item" key={item.label}>
              <div className="fee-item-left">{t(item.label)}</div>
              <span>{item.value}</span>
            </div>
          )
        })}
      </StyledTradeDetailSection>
      {txHash && (
        <StyledTradeDetailLink>
          <a
            href={getExplorerTransactionLink(txHash, chainId)}
            className="link"
            target="_blank"
          >
            {t('check_on_chain_status')}
          </a>
          <img src={IconRight} alt="" />
        </StyledTradeDetailLink>
      )}
      <OrderStatus status={status} tradeType={tradeType} />
    </StyledTradeDetail>
  )
}

export default TradeDetail
